import * as Cesium from "cesium";
import { GeopickingItemDto } from "~/api/GeneratedApi";
import { geopickingToCesiumMapItem } from "./dataConverters";

export function geopickingToCesium(
  viewer: Cesium.Viewer,
  geopicking: GeopickingItemDto[],
): void {
  const pinBuilder = new Cesium.PinBuilder();
  geopicking.forEach((m) => {
    // Convert to internal type
    const convertedGeopick = geopickingToCesiumMapItem(m);
    const { location } = convertedGeopick;
    const { x, y, z } = location;

    // Update or add
    const entity = viewer.entities.getById(convertedGeopick.mapId);
    if (entity) {
      // entity.name = convertedGeopick.name;
      entity.position = new Cesium.ConstantPositionProperty(
        new Cesium.Cartesian3(x, y, z),
      );
      entity.properties = new Cesium.PropertyBag({
        ...convertedGeopick,
      });
    } else {
      const canvas = pinBuilder.fromText("!", Cesium.Color.GREENYELLOW, 48);
      viewer.entities.add({
        id: convertedGeopick.mapId,
        position: new Cesium.Cartesian3(x, y, z),
        properties: new Cesium.PropertyBag({
          ...convertedGeopick,
        }),
        billboard: {
          image: canvas.toDataURL(),
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        },
      });
    }
  });
  // Check for deleted entities
  viewer.entities.values.forEach((e) => {
    if (!e.id.includes("geopicking")) return;
    const found = geopicking.find(
      (g) => geopickingToCesiumMapItem(g).mapId === e.id,
    );
    if (!found) {
      viewer.entities.remove(e);
    }
  });
}
